<template>
  <v-dialog content-class="bottom-sheet-dialog" transition="dialog-bottom-transition" no-click-animation v-resize="onResize" :persistent="persistent" :scrollable="true" v-model="visible" :max-width="inset ? '70%' : '100%'" :fullscreen="$root.bottomSheetFullscreen">
    <v-card tile v-if="this.router">
      <router-view name="bottomEditor" :prependExtraTabs="prependExtraTabs" :appendExtraTabs="appendExtraTabs" :defaultTab="defaultTab"></router-view>
    </v-card>
    <v-card tile v-else>
      <slot></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    persistent: {
      type: Boolean,
      default: true
    },
    router: {
      type: Boolean,
      default: true
    },
    value: Boolean,
    prependExtraTabs: {
      type: Array,
      default: () => []
    },
    appendExtraTabs: {
      type: Array,
      default: () => []
    },
    defaultTab: String
  },
  data () {
    return {
      inset: true
    }
  },
  computed: {
    visible: {
      get () {
        return (this.router && this.$root.bottomSheet) || (!this.router && this.value);
      },
      set (val) {
        if(this.router) this.$root.bottomSheet = val;
        if(!this.router) this.$emit("input", val);
      }
    }
  },
  methods: {
    onResize() {
      if(window.innerWidth < 1440) {
        this.inset = false;
      } else {
        this.inset = true;
      }
    }
  }
}
</script>

<style>

  .v-dialog__content > .bottom-sheet-dialog {
    margin: 20px 0 0 0;
    align-self: flex-end;
  }
  .v-dialog__content > .bottom-sheet-dialog .v-card {
    min-height: 532px;
  }
  .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen {
    margin-top: 0px;
  }
  .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tabs > .v-tabs__bar {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1000;
  }
  .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tab-card > .v-card__text, .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tab-card > div > .v-card__text, .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tab-card > div > form > .v-card__text, .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tab-card > .bottom-sheet-tab-content {
    height: -moz-calc(100vh - 100px) !important;
    height: -webkit-calc(100vh - 100px) !important;
    height: calc(100vh - 100px) !important;
    margin-top: 48px;
    margin-bottom: 52px;
  }
  .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tab-card > div > .v-card__actions, .v-dialog__content > .bottom-sheet-dialog.v-dialog--fullscreen .bottom-sheet-tab-card > div > form > .v-card__actions {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #424242;
    z-index: 1000;
  }
</style>
